import clsx from "clsx"
import { FC, memo, useEffect, useRef } from "react"
import { Card } from "@/ui/Card"
import styles from "./ViewCard.module.scss"
import { IViewCard } from "./types"

const ViewCardComponent: FC<IViewCard> = ({ data, onClose, isMatchActive }) => {
  const resIsCanClose = useRef<boolean>(false)

  useEffect(() => {
    setTimeout(() => {
      resIsCanClose.current = true
    }, 100)
  }, [])

  return (
    <div
      className={clsx(styles.ViewCard, { [styles.active]: !!data })}
      onClick={() => {
        if (!resIsCanClose.current) {
          return
        }
        onClose?.()
      }}
    >
      <div className={clsx(styles.ViewCard_overlay)} />
      <div className={clsx(styles.ViewCard_cardPlace)}>
        <Card
          data={data}
          owner="preview"
          isShowBackSide={false}
          isMatchActive={isMatchActive}
          descriptionScale={0.7}
        />
      </div>
    </div>
  )
}

export const ViewCard = memo(ViewCardComponent)
